import { useState } from 'react'
import { Icon, Modal, StatusType } from 'components'
import { Menu, useMediaQuery, IconButton } from '@mui/material'
import { StatusOV } from 'container/Home/components/Banners/interface'
import { getReasonsRefusal } from 'store/OVContext/ovSlice'
import * as S from './styles'
import { theme } from 'styles/theme/hav-theme'
import { SapOptionsToOvStatus } from 'store/OVContext/ovContextTypes'
import ModalDuplicate from 'container/SalesOrder/components/ModalDuplicate'
import ModalPostOn, {
  ClientsListInterface
} from 'container/SalesOrder/components/ModalPostOn'
import { useDispatch, useSelector } from 'store/store'
import { statusBgKey } from 'commons/styles/StatusBG'

import SapModal, { SapModalTypes } from 'container/ManageOVDetails/components/SapModal'
import ModalTracking from 'container/SalesOrder/components/ModalTracking'
import { ACTIONS_SCREENS, SCREENS } from 'commons/utils/permissions'
import { ActionPerm } from '../Header/constants'
import { usePermissions } from 'commons/customHooks/useAuth'
import { ModalContentLayout } from 'layouts/ModalContentLayout'
import CancelOvForm, {
  CancelOvReason
} from 'container/SalesOrder/components/OvsTab/components/CancelOvForm'
import { toFirsLetterUpper } from 'commons/utils/string'
import { getEDIRowIcon } from 'container/ManageOrders/utils'
import { OriginOrder } from 'constants/enums'
import ModalPendingEDI from 'container/SalesOrder/components/ModalPendingEDI'

export type ToolBarProps = {
  orderNumber?: string
  ovPortalNumber?: string
  ovSapNumber?: string
  materialTypeMTO?: boolean
  orderStatus?: 'initial' | 'created' | 'manage' | 'ordered'
  isDisableButtonCancel?: boolean
  isButtonCancel?: boolean
  onClickCancel?: (data: CancelOvReason) => void
  isDisableButtonRescueData?: boolean
  isButtonRescueData?: boolean
  onClickRescueData?: () => void
  isDisableButtonDownload?: boolean
  isButtonDownload?: boolean
  onClickDownload?: () => void
  isDisableButtonTitles?: boolean
  isButtonTitles?: boolean
  onClickTitles?: () => void
  isDisableButtonDuplicate?: boolean
  isButtonDuplicate?: boolean
  onClickDuplicate?: () => void
  isDisableButtonPostOn?: boolean
  isButtonPostOn?: boolean
  onClickPostOn?: (array: ClientsListInterface[]) => Promise<void>
  isDisableButtonShare?: boolean
  isButtonShare?: boolean
  onClickShare?: () => void
  isDisableButtonTrack?: boolean
  isButtonTrack?: boolean
  isButtonPendingEDI?: boolean
  isDisableButtonPendingEDI?: boolean
  isDisableButtonSave?: boolean
  isLoadingButtonSave?: boolean
  isButtonSave?: boolean
  onClickSave?: () => void
  isDisableButtonDelete?: boolean
  isButtonDelete?: boolean
  onClickDelete?: () => void
  fullWidth?: boolean
  showDeleteModal?: boolean
  showButtonMore?: boolean
  onClickSap?: () => void
  sapButtonsOptions?: SapOptionsToOvStatus
  disableToolbar?: boolean
  isND?: boolean
  originOrder?: OriginOrder
}

export const ToolBar = ({
  orderNumber,
  materialTypeMTO = false,
  orderStatus = 'initial',
  isDisableButtonCancel = false,
  isButtonCancel = false,
  onClickCancel = () => null,
  isDisableButtonRescueData = false,
  isButtonRescueData = false,
  onClickRescueData = () => null,
  isDisableButtonDownload = false,
  isButtonDownload = false,
  onClickDownload = () => null,
  isDisableButtonDuplicate = false,
  isButtonDuplicate = false,
  onClickDuplicate = () => null,
  isDisableButtonPostOn = false,
  isButtonPostOn = false,
  onClickPostOn,
  isDisableButtonShare = false,
  isButtonShare = false,
  onClickShare = () => null,
  isDisableButtonTrack = false,
  isButtonTrack = false,
  isDisableButtonPendingEDI = false,
  isButtonPendingEDI = false,
  isDisableButtonSave = false,
  isLoadingButtonSave = false,
  isButtonSave = false,
  onClickSave = () => null,
  isDisableButtonDelete = false,
  isButtonDelete = false,
  onClickDelete = () => null,
  isButtonTitles,
  isDisableButtonTitles,
  onClickTitles,
  fullWidth = false,
  showDeleteModal = true,
  ovPortalNumber,
  ovSapNumber,
  showButtonMore = true,
  onClickSap = () => null,
  sapButtonsOptions,
  disableToolbar = false,
  isND = false,
  originOrder
}: ToolBarProps) => {
  const isDesktop = useMediaQuery(`(min-width:${theme.breakpoints.md + 1}px)`)
  const [modalDelete, setModalDelete] = useState<boolean>(false)
  const [modalCancel, setModalCancel] = useState<boolean>(false)
  const [modalDuplicate, setModalDuplicate] = useState<boolean>(false)
  const [modalPostOn, setModalPostOn] = useState<boolean>(false)
  const [modalRescueData, setModalRescueData] = useState<boolean>(false)
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [sapModal, setSapModal] = useState<SapModalTypes | undefined>()
  const [modalTracking, setModalTracking] = useState<boolean>(false)
  const [modalPendingEDI, setModalPendingEDI] = useState<boolean>(false)
  const dispatch = useDispatch()
  const {
    ovSelected: { statusOrdemVenda },
    isHAVAConectaOrder
  } = useSelector(({ ov }) => ov)
  const { nr_cpnj_cpf, cd_clie, nm_clie, nr_pedi_rasc } = useSelector(
    ({ salesOrder }) => salesOrder.draftBody
  )
  const { globalLoading } = useSelector((store) => store.structure)
  const { verifyPermission } = usePermissions()

  function shouldDisable(action: ActionPerm) {
    return !verifyPermission(SCREENS.OV, action) || (isHAVAConectaOrder && !!orderNumber)
  }

  const open = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClickRescueData = () => {
    if (onClickRescueData) {
      onClickRescueData()
    }
    setModalRescueData(false)
  }

  const handleClickSave = () => {
    if (onClickSave) {
      onClickSave()
    }
  }
  const handleClickDownload = () => {
    if (onClickDownload) {
      onClickDownload()
    }
  }

  const handleClickDuplicate = () => {
    setModalDuplicate(!modalDuplicate)
  }

  const handleClickPostOn = (array: ClientsListInterface[]) => {
    if (onClickPostOn) {
      onClickPostOn(array)
    }
  }
  const openCancel = () => {
    setModalCancel(true)
    dispatch(getReasonsRefusal())
  }

  const openPostOn = () => {
    setModalPostOn(true)
  }
  const openRescueData = () => {
    setModalRescueData(true)
  }

  const closePostOn = () => {
    setModalPostOn(false)
  }

  const handleClickShare = () => {
    if (onClickShare) {
      onClickShare()
    }
  }
  const handleClickTitles = () => {
    if (onClickTitles) {
      onClickTitles()
    }
  }

  const handleClickTrack = () => {
    setModalTracking(true)
  }

  const handleModalPendingEDI = () => {
    setModalPendingEDI(true)
  }

  const handleClickCancel = (data: CancelOvReason) => {
    if (onClickCancel) {
      onClickCancel(data)
      setModalCancel(false)
    }
  }

  const handleClickDelete = () => {
    if (onClickDelete) {
      onClickDelete()
      setModalDelete(false)
    }
  }

  return (
    <S.Container fullWidth={fullWidth}>
      <S.MainTitle
        status={orderStatus}
        fullWidth={fullWidth}
        type={
          (statusOrdemVenda
            ? StatusOV[statusOrdemVenda].split(' - ')[0]
            : StatusType.PENDENTE) as statusBgKey
        }
      >
        {orderStatus !== 'ordered' ? (
          <>
            <h2>Pedido</h2>
            <h3>{orderNumber ? `#${orderNumber}` : 'Aguardando dados do cliente'}</h3>
          </>
        ) : (
          <>
            <h2>
              {!!statusOrdemVenda &&
                `${statusOrdemVenda.split('-')[0]}- ${toFirsLetterUpper(
                  statusOrdemVenda.split('-')[1]?.trim()
                )}`}
            </h2>
          </>
        )}
      </S.MainTitle>

      {orderStatus !== 'ordered' &&
        !!nr_cpnj_cpf &&
        !!cd_clie &&
        !!nm_clie &&
        orderNumber === nr_pedi_rasc && (
          <S.OrderType>
            <h2>
              Razão social <span> {nm_clie}</span>
            </h2>

            <S.OrderRow>
              <h2>
                SAP <span> {cd_clie}</span>
              </h2>
              <h2>
                CNPJ <span> {nr_cpnj_cpf}</span>
              </h2>
            </S.OrderRow>
          </S.OrderType>
        )}

      {orderStatus === 'ordered' && (
        <S.OvWrapper>
          <S.OvInfo>
            <h2>OV Portal</h2>
            <h3>{ovPortalNumber ?? '---'}</h3>
            <h3>{getEDIRowIcon(originOrder, undefined, true)}</h3>
          </S.OvInfo>

          <S.OvInfo>
            <h2>OV SAP</h2>
            {ovSapNumber ? <h3>{ovSapNumber}</h3> : <h4>Não gerado</h4>}
          </S.OvInfo>
        </S.OvWrapper>
      )}

      <S.Actions>
        {isDesktop ? (
          <>
            {isButtonPendingEDI && (
              <S.ActionButton
                id="btn-share"
                fullfill={false}
                onClick={handleModalPendingEDI}
                disabled={isDisableButtonPendingEDI || disableToolbar}
              >
                <Icon icon="info" size="18" />
                Pendências
              </S.ActionButton>
            )}
            {isButtonShare && (
              <S.ActionButton
                id="btn-share"
                fullfill={false}
                onClick={handleClickShare}
                disabled={isDisableButtonShare || disableToolbar}
              >
                <Icon icon="share" size="18" />
                Compartilhar
              </S.ActionButton>
            )}
            {isButtonTitles && (
              <S.ActionButton
                fullfill={false}
                onClick={handleClickTitles}
                disabled={isDisableButtonTitles || disableToolbar}
                id="btn-title"
              >
                <Icon icon="request-quote" size="18" />
                Títulos
              </S.ActionButton>
            )}
            {isButtonDownload && orderStatus !== 'initial' && (
              <S.ActionButton
                fullfill={false}
                onClick={handleClickDownload}
                disabled={isDisableButtonDownload || disableToolbar}
                id="btn-download"
              >
                <Icon icon="download" size="18" />
                Baixar
              </S.ActionButton>
            )}
            {isButtonTrack && (
              <S.ActionButton
                fullfill={false}
                onClick={handleClickTrack}
                disabled={isDisableButtonTrack || disableToolbar}
                id="btn-tracking"
              >
                <Icon icon="track" size="18" />
                Tracking
              </S.ActionButton>
            )}
            {isButtonRescueData && (
              <S.ActionButton
                fullfill={false}
                onClick={() => !globalLoading && openRescueData()}
                disabled={isDisableButtonRescueData || disableToolbar}
                globalLoading={globalLoading}
                id="btn-rescue-data"
              >
                <Icon icon="history" size="18" />
                Resgatar Dados
              </S.ActionButton>
            )}
            {isButtonTrack && (
              <ModalTracking
                open={modalTracking}
                setOpen={() => setModalTracking(!modalTracking)}
              />
            )}
            {isButtonDuplicate && (
              <S.ActionButton
                fullfill={false}
                onClick={() => !globalLoading && handleClickDuplicate()}
                disabled={isDisableButtonDuplicate || disableToolbar}
                globalLoading={globalLoading}
                id="btn-duplicate"
              >
                <Icon icon="duplicate" size="18" />
                Duplicar
              </S.ActionButton>
            )}

            {isButtonPostOn && (
              <S.ActionButton
                fullfill={false}
                onClick={() => !globalLoading && openPostOn()}
                disabled={isDisableButtonPostOn || disableToolbar}
                globalLoading={globalLoading}
                id="btn-post-on"
              >
                <Icon icon="post-on" size="18" />
                Listar
              </S.ActionButton>
            )}
            {isButtonCancel && (
              <S.ActionButton
                fullfill={false}
                onClick={() => !globalLoading && openCancel()}
                disabled={isDisableButtonCancel || disableToolbar}
                globalLoading={globalLoading}
                id="btn-cancel"
              >
                <Icon icon="cancel" size="18" />
                Cancelar
              </S.ActionButton>
            )}
            {isButtonDelete && (
              <S.ActionButton
                fullfill={false}
                onClick={
                  globalLoading
                    ? undefined
                    : showDeleteModal
                    ? () => setModalDelete(true)
                    : () => handleClickDelete()
                }
                globalLoading={globalLoading}
                disabled={isDisableButtonDelete || disableToolbar}
                id="btn-delete"
              >
                <Icon icon="trash" size="18" />
                Excluir
              </S.ActionButton>
            )}

            {isButtonSave && ['initial', 'created', 'ordered'].includes(orderStatus) && (
              <S.ActionButton
                fullfill={orderStatus !== 'ordered'}
                onClick={() => !globalLoading && handleClickSave()}
                disabled={isDisableButtonSave || disableToolbar}
                globalLoading={globalLoading}
                id="btn-save"
              >
                {isLoadingButtonSave ? (
                  <S.CircularProgressStyled
                    size="2rem"
                    fullfill={orderStatus !== 'ordered'}
                  />
                ) : (
                  <>
                    <Icon icon="save" size="18" /> Salvar
                  </>
                )}
              </S.ActionButton>
            )}

            {(sapButtonsOptions?.isValidToReturnFromSap ||
              sapButtonsOptions?.isValidToReturnToSalesArea) && (
              <S.ActionButton
                fullfill
                sapButton={sapButtonsOptions?.isValidToReturnFromSap}
                disabled={shouldDisable(ACTIONS_SCREENS.RETURN)}
                onClick={() => setSapModal('returnModal')}
                id="btn-return"
              >
                <Icon icon="undo" size="18" />
                Retornar
              </S.ActionButton>
            )}
            {sapButtonsOptions?.isValidToSendToSap && (
              <S.ActionButton
                fullfill={!isHAVAConectaOrder && !orderNumber}
                sapButton={sapButtonsOptions?.isValidToSendToSap}
                disabled={shouldDisable(ACTIONS_SCREENS.SEND)}
                onClick={() => setSapModal(isND ? 'sendModalND' : 'sendModal')}
                id="btn-send"
              >
                <Icon icon="send" size="18" />
                Enviar
              </S.ActionButton>
            )}
          </>
        ) : (
          <div>
            {showButtonMore && (
              <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
              >
                <S.HamburguerMenuWrapper>
                  <Icon icon="menu" color={theme.colors.primary.main} size="18" />
                </S.HamburguerMenuWrapper>
              </IconButton>
            )}
            <Menu
              id="long-menu"
              MenuListProps={{
                'aria-labelledby': 'long-button'
              }}
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              {isButtonShare && (
                <S.StyledMenuItem
                  disabled={isDisableButtonShare || disableToolbar}
                  onClick={() => {
                    handleClickShare()
                    handleClose()
                  }}
                  id="btn-share-tablet"
                >
                  Compartilhar
                </S.StyledMenuItem>
              )}

              {isButtonTitles && (
                <S.StyledMenuItem
                  disabled={isDisableButtonTitles || disableToolbar}
                  onClick={() => {
                    handleClickTitles()
                    handleClose()
                  }}
                  id="btn-title-tablet"
                >
                  Títulos
                </S.StyledMenuItem>
              )}
              {isButtonDownload && orderStatus !== 'initial' && (
                <S.StyledMenuItem
                  disabled={isDisableButtonDownload || disableToolbar}
                  onClick={() => {
                    handleClickDownload()
                    handleClose()
                  }}
                  id="btn-download-tablet"
                >
                  Baixar
                </S.StyledMenuItem>
              )}
              {isButtonTrack && (
                <S.StyledMenuItem
                  disabled={isDisableButtonTrack || disableToolbar}
                  onClick={() => {
                    handleClickTrack()
                    handleClose()
                  }}
                  id="btn-tracking-tablet"
                >
                  Tracking
                </S.StyledMenuItem>
              )}
              {isButtonRescueData && (
                <S.StyledMenuItem
                  disabled={isDisableButtonRescueData || disableToolbar}
                  onClick={() => {
                    openRescueData()
                    handleClose()
                  }}
                  id="btn-rescue-data-tablet"
                >
                  Resgatar Dados
                </S.StyledMenuItem>
              )}
              {isButtonDuplicate && (
                <S.StyledMenuItem
                  disabled={isDisableButtonDuplicate || disableToolbar}
                  onClick={() => {
                    handleClickDuplicate()
                    handleClose()
                  }}
                  id="btn-duplicate-tablet"
                >
                  Duplicar
                </S.StyledMenuItem>
              )}
              {isButtonPostOn && (
                <S.StyledMenuItem
                  disabled={isDisableButtonPostOn || disableToolbar}
                  onClick={() => {
                    openPostOn()
                    handleClose()
                  }}
                  id="btn-post-on-tablet"
                >
                  Listar
                </S.StyledMenuItem>
              )}
              {isButtonCancel && (
                <S.StyledMenuItem
                  disabled={isDisableButtonCancel || disableToolbar}
                  onClick={() => {
                    openCancel()
                    handleClose()
                  }}
                  id="btn-cancel-tablet"
                >
                  Cancelar
                </S.StyledMenuItem>
              )}

              {isButtonDelete && (
                <S.StyledMenuItem
                  disabled={isDisableButtonDelete || disableToolbar}
                  onClick={() => {
                    if (showDeleteModal) {
                      setModalDelete(true)
                      handleClose()
                    } else {
                      handleClickDelete()
                    }
                  }}
                  id="btn-delete-tablet"
                >
                  Excluir
                </S.StyledMenuItem>
              )}

              {isButtonSave && ['initial', 'created', 'ordered'].includes(orderStatus) && (
                <S.StyledMenuItem
                  disabled={isDisableButtonSave || disableToolbar}
                  onClick={() => {
                    handleClickSave()
                    handleClose()
                  }}
                  id="btn-save-tablet"
                >
                  Salvar
                </S.StyledMenuItem>
              )}

              {(sapButtonsOptions?.isValidToReturnFromSap ||
                sapButtonsOptions?.isValidToReturnToSalesArea) && (
                <S.StyledMenuItem
                  disabled={shouldDisable(ACTIONS_SCREENS.RETURN)}
                  onClick={() => {
                    setSapModal('returnModal')
                    handleClose()
                  }}
                  id="btn-return-tablet"
                >
                  Retornar
                </S.StyledMenuItem>
              )}

              {sapButtonsOptions?.isValidToSendToSap && (
                <S.StyledMenuItem
                  disabled={shouldDisable(ACTIONS_SCREENS.SEND)}
                  onClick={() => {
                    setSapModal('sendModal')
                    handleClose()
                  }}
                  id="btn-send-tablet"
                >
                  Enviar
                </S.StyledMenuItem>
              )}
            </Menu>
          </div>
        )}
      </S.Actions>

      <Modal
        open={modalDelete}
        setOpen={setModalDelete}
        title={ovPortalNumber ? 'Excluir' : 'Excluir pedido'}
        description={
          ovPortalNumber
            ? 'Esta ação excluirá os itens inclusos nesta OV e eles serão removidos do seu pedido.'
            : 'Todos os materiais serão excluídos. Deseja continuar?'
        }
        showReturn
        returnText="Voltar"
        buttonText="Excluir"
        buttonAction={handleClickDelete}
      />
      {modalCancel && (
        <ModalContentLayout
          closeAction={() => setModalCancel(false)}
          title="Cancelar"
          description={
            'Deste modo os itens inclusos nesta Ordem de venda deixarão de ser faturados. Para continuar insira a justificativa para a ação.'
          }
        >
          <CancelOvForm setOpen={setModalCancel} cancelAction={handleClickCancel} />
        </ModalContentLayout>
      )}

      <Modal
        open={modalRescueData}
        setOpen={setModalRescueData}
        title="Resgatar dados"
        description='Ao clicar em "Resgatar Dados", os campos listados a seguir serão resgatados do último pedido digitado e preenchidos automaticamente, sobrepondo qualquer outra informação: Tipo de OV, Condições de Pagamento, Prazo Extra, Desconto e Texto para expedição em caso de MTO.'
        showReturn
        returnIcon={<></>}
        returnText="Voltar"
        buttonText="Confirmar"
        buttonAction={handleClickRescueData}
      />
      <ModalDuplicate
        open={modalDuplicate}
        setOpen={() => setModalDuplicate(!modalDuplicate)}
        handleDuplicated={() => {
          onClickDuplicate()
          setModalDuplicate(false)
        }}
      />
      {orderNumber && (
        <ModalPostOn
          open={modalPostOn}
          setOpen={setModalPostOn}
          orderNumber={orderNumber}
          handlePostOn={handleClickPostOn}
          handleCancel={closePostOn}
        />
      )}
      {isButtonTrack && (
        <ModalTracking
          open={modalTracking}
          setOpen={() => setModalTracking(!modalTracking)}
        />
      )}
      <ModalPendingEDI
        open={modalPendingEDI}
        setOpen={() => setModalPendingEDI(!setModalPendingEDI)}
      />
      <SapModal
        handleButtonAction={() => onClickSap()}
        sapModal={sapModal}
        setSapModal={setSapModal}
      />
    </S.Container>
  )
}
